import Api from '@/api/index';
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  props:{
    wholesale:{
      type: Boolean,
      default: true
    },
    hide_ids:{
      type: Array,
      default: () => []
    },
    multiple:{
      type: Boolean,
      default: false
    },
  },
  data(){
    return {
      loading_modules: false,
      selected_modality: null,
      set_selected_id: false,
      modalities: []
    }
  },
  methods: {
    getData() {
      this.getModalities()
    },  
    getModalities(){
      if(this.current_user_role_name){
        this.loading_modules = true
        Api.Modality.indexByCurrentUser().then(r => r.data).then((data)=>{
          
          this.modalities = [...data].sort((a, b)=> {
            if(a.solution == 'wholesale'){
              return -1;
            }
          })

          if(this.modalities.length > 1){
            this.modalities.unshift({name:"Listar todos módulos", id: -1})
          }
          
        }).finally(()=>{
          this.getActiveModalityId()
          this.setSelectedIds()
          this.loading_modules = false
        })
      }
    },
    getActiveModalityId() {
      const activeModalityId = localStorage.getItem('modality_id')
      let dontHaveModality = false
      if (activeModalityId) {
        const parsedactiveModalityId = parseInt(activeModalityId);
        const depotExists = this.filter_modalities.some(modality => modality.id === parsedactiveModalityId);
        if (depotExists && !this.multiple) {
          this.selected_modality = parsedactiveModalityId;
        } else {
          dontHaveModality = true
        }
      } else {
        dontHaveModality = true
      }
      if( dontHaveModality && !this.multiple ){
        if (this.filter_modalities.length > 0) {
          this.selected_modality = this.filter_modalities[0];
          this.setactiveModalityId(this.selected_modality?.id)
          this.setactiveModalitySolution(this.selected_modality?.solution)
          this.setActiveDepotName(this.selected_modality?.name)
        }
      }
    },
    setSelectedIds(){
      if(this.selected_ids != null){
        this.selected_modality = [...this.selected_ids]
      }
    },
    async handleSelectedDepot(new_value){
      this.$emit('selectModality', new_value)
      let id = new_value?.id || new_value

      let modality = await this.modalities.filter(d => d.id == id)[0]

      if(typeof(new_value == 'number') && !this.multiple){

        this.setactiveModalityId(id)
        this.setactiveModalitySolution(modality?.solution)
        this.setActiveDepotName(modality?.name)
      }
    },
    ...mapActions({
      setactiveModalityId: 'App/setactiveModalityId',
      setactiveModalitySolution: 'App/setactiveModalitySolution',
      setActiveDepotName: 'App/setActiveDepotName',
    })
  },
  computed:{
    can_see_wholesale(){
      return ( this.wholesale && this.isDirector() || this.current_user_employee.used_in_wholesale)
    },
    filter_modalities(){
      return this.modalities.filter(el => !this.hide_ids?.includes(el.id) )
    },
    wholesale_selected(){
      return this.selected_modality?.solution == 'wholesale'
    },
  },
  watch:{
    current_user_role_name(nv){
      this.getData()
    },
    selected_modality(new_value,old_value){
      this.handleSelectedDepot(new_value)
    },
    selected_ids(new_ids, old_ids){
      if(!this.set_selected_id){
        this.setSelectedIds()
        this.set_selected_id = true
      }
    }
  },
  mounted() {
    this.getData()
  },
}